import _ from 'lodash';
import angular from 'angular';

import ConvertAfebToMesh from './afeb-conventor';
import getSelectOptions from './select-options';
import FieldProcessor from './field-processor';

import selectBlankBoundaries from './boundaries-helpers';

const EXPARATION_NOTIFICATION_GAP = 17*60*1000;

class LoadedModel {

    constructor($resource, $state, $rootScope, $interval) {
        this._$resource = $resource;
        this._$state = $state;
        this._$rootScope = $rootScope;
        this._afebConvertor = new ConvertAfebToMesh();
        this._options = getSelectOptions();
        this.fieldProcessor = new FieldProcessor();
        this.setDefaultParams();
        $interval(() => {
            if(this.showExpirationDialog()) {
                this._$rootScope.$broadcast('showExpirationDialog');
            }
        }, 5000);
    }

    showExpirationDialog() {
        return this.expirationTime && this.hasMesh() && !this.requestInProgress && Date.now() - EXPARATION_NOTIFICATION_GAP > this.expirationTime
    }

    setDefaultParams(stepToOmit) {
        let fields = this.fieldProcessor.getDefaultParams();
        let fieldsToOmit = [];

        if (stepToOmit) {
            this.getPassedStepsByStep(stepToOmit).forEach((step)=> {
                fieldsToOmit = fieldsToOmit.concat(this.fieldProcessor.getUIKeysByStep(step));
            });
            fields = _.omit(fields, fieldsToOmit);
        }

        for (const key in fields) {
            this[key] = fields[key];
        }
    }

    set unit(newName) {
        this._unit = newName;
        this._thickness =  this._unit.value === 'psi' ?  this.convertMetricToPSI(this._thickness) : this.convertPSIToMetric(this._thickness);
        this._$rootScope.$broadcast('partStepChanged');
    }

    get boundaries() {
        return this._boundaries;
    }

    set boundaries(data) {
        this._boundaries = data;
        if (data) {
            const [v1, v2] = data;
            const dx = v1.x - v2.x;
            const dy = v1.y - v2.y;
            const dz = v1.z - v2.z;
            this.maxDimensions = Math.sqrt( dx * dx + dy * dy + dz * dz );
        } else {
            this.maxDimensions = undefined;
        }
    }

    get unit() {
        return this._unit;
    }

    get systemsOfMeasurementUnit() {
        return this._unit.value === 'psi' ? 'inch' : 'mm';
    }

    get orientType() {
        return this._orientType;
    }

    set orientType(value) {
        this._orientType = value;
        // this.orientAngle = undefined;
    }

    get thickness() {
        return this._thickness;
    }

    thicknessGetFocus() {
        this._thicknessTMP = this._thickness;
    }

    invalidateThickness() {
        if (this._thicknessTMP !== this._thickness) {
            this._thicknessTMP = this._thickness;
            this._$rootScope.$broadcast('partStepChanged');
        }
    }

    set thickness(value) {
        this._thickness = value;
        this._$rootScope.$broadcast('thicknessChanged', value);
    }

     isThicknessValid() {
      const limitValue = this._unit.value === 'psi' ? this.convertMetricToPSI(8) : 8;
      return this._thickness <= limitValue;
    }

    set holdingCond(newName) {
        this._holdingCond = newName;
        this._$rootScope.$broadcast('formingTypeChanged', newName);
    }

    get holdingCond() {
        return this._holdingCond;
    }

    getCurrNestValues() {
        let result = {
          materialCost: this.materialCost,
          priceUnit: this.priceUnit.value,
          addWidth: this.addWidth,
          bridgeSpan: this.bridgeSpan,
          nType: this.nType.value,
          orientType: this.orientType.value,

        };
        if (result.orientAngle) {
          result.orientAngle = this.orientAngle;
        }
        return result
    }

    getCurrBlankValues() {
      return {
        customWidth: this.customWidth,
      }
    }

    getNestBoundaries() {
        let result = [this.nestN2,];
        if (this.nestN3) {
            result.push(this.nestN3);// Tmp changes should be returned after some testing.
        }
        return result;
    }

    getFloatPitch() {
        return this.pitch ? parseFloat(this.pitch.replace(',', '.'), 2) : undefined;
    }

    convertToCurrentSys(value) {
        return this._unit.value === 'psi' ? value * 25.4 : value;
    }

    getViewData(key) {
        const dataMapper =  {
            blank: [this.boundary, this.meshLL, this.maxDimensions],
            feasibility: [this.getFormabilityData(), this.maxDimensions],
            thinning: [this.getThinningData(), this.maxDimensions],
            nest: [this.getNestBoundaries(), this.calculateEdges(), this.convertToCurrentSys(this.getFloatPitch()),],
            mesh: {
                fileName: this.fileName,
                mesh: this.mesh,
                maxDimensions:  this.maxDimensions
            }};
        return dataMapper[key];
    }


    set selectedReportView(newValue) {
        this._selectedReportView = newValue;
        const value = newValue.value;
        const view = this[this.getViewMapper()[value]];
        if (view) {
            this._$rootScope.$broadcast('updateView', [undefined, view, value]);
        } else {
            this._$rootScope.$broadcast('updateView', [this.getViewData(value), undefined, value]);
        }
    }

    get selectedReportView() {
        return this._selectedReportView;
    }

    updateSim(simData) {
        Object.keys(simData).forEach((key) => {
            this[key] = simData[key];
        });
    }

    updateSimAndCash(holdingCond, simData) {
        this.cashedSim[holdingCond] = simData;
        this.updateSim(simData);
    }

    getCashed() {
        return this.cashedSim[this.holdingCond] || false;
    }

    getCashedSimView() {
      const holdViews  = this.cashedSimViews[this.holdingCond] || false;
      if (holdViews) {
          return holdViews[this.results] || false;
      } else {
          return false;
      }
    }

    setCashedView(view) {
      let holdViews  = this.cashedSimViews[this.holdingCond] || false;
      if (!holdViews) {
        this.cashedSimViews[this.holdingCond] = {};
          holdViews = this.cashedSimViews[this.holdingCond];
      }
      holdViews[this.results] = view;
    }

    getMeshLL() {
        const cashedData = this.cashedSim[this.holdingCond];
        if (cashedData) {
            return cashedData.meshLL;
        } else {
            return this.meshLL;
        }
    }

    updateBoundary () {
        const useCustom = this.showWidthInput && this.isUsedCustomWidth;
        const dataFile = useCustom ? this.blankBoundaryModCustom: this.blankBoundaryMod;
        const width = useCustom ? 4 : this.width;
        const meshLL = this.getMeshLL();
        if(dataFile) {
            this._$rootScope.$broadcast('updateView', [[selectBlankBoundaries(dataFile, this._convex,  this._smooth, width), meshLL, this.maxDimensions], undefined, 'blank']);
        }
    }

    set smooth(value) {
        this._smooth = value;
        this.updateBoundary();
        this.invalidateSnapshots('blank');
        this.invalidateStep('blank');
    }

    get smooth() {
        return this._smooth;
    }

    set width(value) {

        const round = (value) => {
            if (this._unit.value === 'psi') {
               return value.toFixed(1);

            } else {
                return value.toFixed(0)
            }
        }
        this._width = value;
        if (this._unit.value === 'psi') {
            this.calculatedWidth = round(value / 4 * this.mex/25.4);
        } else {
            this.calculatedWidth = round(value / 4 * this.mex);
        }
        this.isUsedCustomWidth = false;
        this.updateBoundary();
        this.invalidateSnapshots('blank');
        this.invalidateStep('blank');

    }

    get width() {
        return this._width;
    }

    set convex(value) {
        this._convex = value;
        this.updateBoundary();
        this.invalidateSnapshots('blank');
        this.invalidateStep('blank');
    }

    get convex() {
        return this._convex;
    }

    set results(newName) {
        this._results = newName;
        if(newName === 'thinning') {
            this._$rootScope.$broadcast('updateView', [[this.getThinningData(), this.maxDimensions], undefined, 'thinning']);
        } else {
            this._$rootScope.$broadcast('updateView', [[this.getFormabilityData(),this.maxDimensions ], undefined, 'feasibility']);
        }
    }

    get material() {
        return this._material;
    }

    set material(value) {
        this._material = value;
        this._$rootScope.$broadcast('partStepChanged');
    }

    get offset() {
        return this._offset;
    }

    set offset(value) {
        this._offset = value;

        const view = this[this.getViewMapper()['mesh']];

        if (view) {
            let data = view.data;
            data.offset = value;
            this._$rootScope.$broadcast('updateView', [view.data, view, 'mesh', true]);
        }

        this._$rootScope.$broadcast('partStepChanged');
    }

    get results() {
        return this._results;
    }

    isStepPassed(step) {
        return this.passedSteps.indexOf(step) !== -1;
    }

    calculateEdges() {
      // TODO find correct formulas
      return {
          bridgeSpan: _.isNaN(parseFloat(this.bridgeSpan)) ? 0 : parseFloat(this.bridgeSpan),
          edge: this.convertToCurrentSys(_.isNaN(parseFloat(this.addWidth)) ? 0 : parseFloat(this.addWidth))
      };
    }

    getBoundaryData() {
        // return this.blankBoundaryMod || this.boundary;
        return this.boundary;
    }

    getThinningData() {
        return this._afebConvertor.convertThinning(this.afeb);
    }

    getFormabilityData() {
        return this._afebConvertor.convertFormability(this.afeb);
    }

    hasMesh() {
        return !!this.mesh;
    }

    uuid(){
        var d = new Date().getTime();
        if(window.performance && typeof window.performance.now === "function"){
            d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuid;
    }

    getProgress(timeStamp, step, first) {
        let req = first ? {first: true}: {};
        req.timestamp = timeStamp;
        this._$resource('/api/progress')
            .get(req)
            .$promise.then((data) => {
                this._$rootScope.$broadcast('progressUpdated', {step: step, key: data.progress});
                if (this.requestInProgress && data.progress !== 'finish') {
                    this.getProgress(data.timestamp, step);
                }
            });
    }

    fillProperties(resource, step, uniqParam) {
        this.fieldProcessor.getStepValues()[step].forEach((key) => {
            resource[key] = this[key];
        });
        resource.timestamp = uniqParam;
        resource.passedSteps = this.addPassedStep(step);
        return resource;
    }

    getInvalidateKeys(step) {
        return  this.fieldProcessor.getInvalidatedKeys(step);
    }

    addPassedStep(step) {
        const mapper = {
            clear: [],
            part: ['part',],
            feasibility: ['part', 'feasibility'],
            blank: ['part', 'feasibility', 'blank'],
            nest: ['part', 'feasibility', 'blank', 'nest'],
            report: ['part', 'feasibility', 'blank', 'nest']
        };
        return mapper[step];
    }

    takeSnapshot(viewName, reportType) {
        const snapshot =  this.getBase64Image(viewName);
        if (snapshot) {
            this.snapshots.push({
                image: snapshot,
                type: viewName,
                index: Date.now(),
                selected: false,
                default:  reportType
            });
        }
    }

    getBase64Image(viewName) {
        const view = this[viewName];
        if(view) {
            return view.getBase64Image();
        } else {
            return false;
        }
    }

    getPassedStepsByStep(step) {
        const stepMapper = {
            'part': ['part'],
            'feasibility': ['part', 'feasibility'],
            'blank': ['part', 'feasibility', 'blank'],
            'nest': ['part', 'feasibility', 'blank', 'nest'],
        }
        return stepMapper[step];
    }

    invalidateSnapshots(step) {
        const invalidateMap = {
            feasibility: ['thinningView', 'formabilityView', 'blankView', 'nestView'],
            part: ['thinningView', 'formabilityView', 'blankView', 'nestView'],
            blank: ['blankView', 'nestView'],
            nest: ['nestView'],
        }
        _.remove(this.snapshots, (item) => {
            if (invalidateMap[step].indexOf(item.type) === -1) {
                return false;
            } else {
                return true;
            }
        });
    }

    invalidateUI(step) {
        this.setDefaultParams(step);
        this.invalidateSnapshots(step);
        this.passedSteps = this.getPassedStepsByStep(step)
    }

    invalidateStep(step) {
        this._$rootScope.$broadcast('solverStarted', 'Invalidating');
        this.sendInvalidateRequest(step).then(() => {
            this.generateExpTime();
            this.invalidateUI(step);
            this._$rootScope.$broadcast('solverFinished', 'Invalidating');
            this._$rootScope.$broadcast('updateSteps', {step: step});
        }, (err) => {
            this._$rootScope.$broadcast('showErrorDialog', {type: 'error'});
            this.generateExpTime();
            this._$rootScope.$broadcast('solverFinished', 'Invalidating');
            // TODO handle me
        });
    }

    sendInvalidateRequest(step) {
        let res = new this._$resource('/api/invalidate');
        return res.save({step: step}).$promise;
    }

    sendReport(uniqParam) {
        // const promise = new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            let fd = new FormData();

            const dataURLtoFile = (dataurl) =>  {
                const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1];
                const binary = atob(dataurl.split(',')[1]);
                let array = [];
                for(var i = 0; i < binary.length; i++) array.push(binary.charCodeAt(i));
                return new Blob([new Uint8Array(array)], {type:mime});
            };

            const keyList = [
              'materialCost',
              'scrapVal',
              'fileName',
              'partsNumber',
              'userLastName',
              'email',
              'comment',
              'organization',
              'name',
              'snapshots',
              'addNumber',
              'phone',
              'phoneCode'
            ];

            keyList.forEach((key) => {
                fd.append(key, this[key]);
            });
            let imageTypes = [];
            const selectedSnapshots = this.getSelectedSnapshots();
            selectedSnapshots.forEach((snapshot, index) => {
                const fileName = `image${index}`;
                fd.append("file", dataURLtoFile(snapshot.image), fileName);
                imageTypes.push(snapshot.type);
            });

            const errorHandler = (error) => {
                try {
                    const result = JSON.parse(error.target.response);
                    this._$rootScope.$broadcast('showErrorDialog', {text: result});
                } catch(err) {
                      this._$rootScope.$broadcast('showErrorDialog', {type: 'error'});
                }
                this.generateExpTime();
                this._$rootScope.$broadcast('solverFinished', 'report');
                this.requestInProgress = false;
            };

            fd.append('imageTypes', imageTypes);
            fd.append('timestamp', uniqParam);

            xhr.open("POST", 'api/solver/report', true);
            xhr.send(fd);

            xhr.onload = (resp) => {
                if([500, 503].indexOf(resp.target.status) === -1) {
                    this.requestInProgress = false;
                    this.generateExpTime();
                    const result = JSON.parse(resp.target.response);
                    this._$rootScope.$broadcast('sendReportData', result);
                    this._$rootScope.$broadcast('solverFinished', 'report');
                    this.calculateUtilizationInfo();
                } else {
                    errorHandler(resp);
                }
            };

            xhr.onerror = (err) => {
                errorHandler(resp);
            };

            xhr.timeout = (err) => {
                errorHandler(resp);
            };
    }

    sendUserData(uuid) {
        const res = new this._$resource('/api/save-user-info');
        return res.save({
            uuid: uuid,
            email: this.email,
            name: this.name,
            userLastName: this.userLastName,
            organization: this.organization,
            phoneCode: this.phoneCode,
            phone: this.phone,
            addNumber: this.addNumber
        }).$promise;
    }

    saveUserDetails() {
        localStorage.setItem('userInfoDetails', JSON.stringify({
          email: this.email,
          name: this.name,
          userLastName: this.userLastName,
          organization: this.organization,
          phoneCode: this.phoneCode,
          phone: this.phone,
          addNumber: this.addNumber
        }));
    }

    getUserInfo(uuid) {
        const res = new this._$resource('/api/get-user-info');
        return res.get({
          uuid: uuid,
        }).$promise.then((data)=> {
            this.email = data.email;
            this.name = data.name;
            this.userLastName = data.userLastName;
            this.organization = data.organization;
            this.phoneCode = data.phoneCode;
            this.phone = data.phone;
            this.addNumber = data.addNumber === 'true'? true: false;
        }, (error) => {
            this.email = ''
            this.name = '';
            this.userLastName = '';
            this.organization = '';
            this.phoneCode = '';
            this.phone = '';
            this.addNumber = false;
        });
    }

    restoreUserDetails() {
        const dataToParse = localStorage.getItem('userInfoDetails');
        if(dataToParse ) {
          const data = JSON.parse(dataToParse);
          this.email = data.email;
          this.name = data.name;
          this.userLastName = data.userLastName;
          this.organization = data.organization;
          this.phoneCode = data.phoneCode;
          this.phone = data.phone;
          this.addNumber = data.addNumber;
        }
        return !!dataToParse;
    }

    getSelectedSnapshots() {
        return this.snapshots.filter((snapshot)=> {
            return snapshot.selected === true;
        });
    }

    getSnapshotsLength() {
        return this.getSelectedSnapshots().length;
    }

    generateExpTime() {
        this.expirationTime = Date.now();
    }

    getErrResponse(res) {
        let result = "Missing response from server";
        try {
            result = JSON.parse(res).error;
        } catch (err) {}
        return result;
    }

    uploadFile(geometry) {
        this._$rootScope.$broadcast('solverStarted', 'part');
        this.setDefaultParams();
        let xhr = new XMLHttpRequest();
        let formData = new FormData();
        const timeStamp = this.uuid();

        formData.append("file", geometry.rawData);
        formData.append("fileName", geometry.fileName);
        formData.append("passedSteps", this.addPassedStep('part'));
        formData.append("timestamp", timeStamp);
        formData.append("name", this.name);
        formData.append("userLastName", this.userLastName);
        formData.append("email", this.email);
        formData.append("organization", this.organization);
        formData.append("phoneCode", this.phoneCode);
        formData.append("phone", this.phone);
        formData.append("addNumber", this.addNumber);

        xhr.open("POST", 'api/file-upload', true);
        xhr.send(formData);

        this.requestInProgress = true;
        this.getProgress(timeStamp, 'part', true);
        setTimeout(()=> {
            this._$rootScope.$broadcast('meshError', undefined);
        });

        const showError = (resp) => {
            this._$rootScope.$broadcast('meshError', this.getErrResponse(resp.target.response));
            this.requestInProgress = false;
            this._$rootScope.$broadcast('solverFinished', {
                step: 'part',
                error: true
            });
        };

        xhr.onload = (resp) => {
            if([500, 503].indexOf(resp.target.status) === -1) {
                this.generateExpTime();
                this.requestInProgress = false;
                this._$rootScope.$broadcast('meshError', undefined);
                let result = JSON.parse(xhr.response);
                this.passedSteps = result.passedSteps;

                this.boundaries = result.boundaries;

                if (this.boundaries[2]) {
                  this._offset = result.offset;
                  this._$rootScope.$broadcast('meshedFileSurface', this.boundaries[2]);
                }

                this._$rootScope.$broadcast('solverFinished', {
                    step: 'part'
                });
                const updateData = {
                    fileName: geometry.fileName,
                    mesh: result.mesh,
                    maxDimensions: this.maxDimensions,

                };
                if (result.lockOffset) {
                    updateData.offset = result.offset;
                    updateData.lockOffset = result.lockOffset;
                    updateData.thickness =  result.thickness;
                } else {
                    updateData.offset = this.offset,
                    updateData.thickness = this.thickness
                }
                this.position = {};
                this._$rootScope.$broadcast('fileMeshed', updateData);
                this._$rootScope.$broadcast('updateView', [updateData, this.meshView, 'mesh']);
            } else {
                showError(resp);
            }
        };

        xhr.ontimeout = (resp) => {
            showError(resp, true);
            // this._$rootScope.$broadcast('meshError', "Server haven't sent response");
        }

        xhr.onerror = (resp) => {
            showError(resp);
        }
    }

    getOffsetName() {
        return this.offset.name;
    }

    clearCurrentView() {
        this.currentView = undefined;
    }

    getViewMapper() {
        return {
            mesh:  'meshView',
            feasibility:  'formabilityView',
            thinning:  'thinningView',
            blank: 'blankView',
            nest: 'nestView',
        };
    }

    getViewKey(key) {
        return this.getViewMapper()[key];
    }

    updateView(view, type) {
        this[this.getViewMapper()[type]] = view;
    }

    getView(type) {
        return this[this.getViewMapper()[type]];
    }

    getUrl(step) {
        const mapper =  {
            feasibility: 'solver/feasibility',
            nest: 'solver/nest',
            blank: 'solver/blank',
            report: 'solver/report',
            clear: 'clear-session',
        }
        return mapper[step];
    }

    saveDataAndReturnPromise(res) {
        return new Promise((resolve, reject) => {
            res.$save().then((results) => {
                resolve(results);
            }, (results) => {
                reject(results);
            });
        });
    }

    sendData(step, suppressBroadcast = false, uniqParam) {
        let url = this.getUrl(step);
        console.log('Sending data to ' + step);
        let MeshResource = this._$resource('/api/' + url, {}, { withCredentials : true });
        if (!suppressBroadcast) {
            this._$rootScope.$broadcast('solverStarted', step);
        }
        return this.saveDataAndReturnPromise(this.fillProperties(new MeshResource(), step, uniqParam));
    }

    clearSession() {
        this._$rootScope.$broadcast('solverStarted', 'clear');
        const res = this.sendData('clear', true);
        this.requestInProgress =  true;
        res.then(() => {
            this.requestInProgress = false;
            this.generateExpTime();
            this._$rootScope.$broadcast('solverFinished', {step: 'clear'});
            this.setDefaultParams();
            this._$rootScope.$broadcast('meshDeleted', true);
            this._$state.go('home', {delete: true});
        }, () => {
            this._$rootScope.$broadcast('showErrorDialog', {type: 'error'});
            this.requestInProgress = false;
            this.generateExpTime();
            this._$rootScope.$broadcast('solverFinished', {step: 'clear'});
          // Handle me
        });

        return res;
    }

    getCurrentSession() {
        if (!this.mesh) {

            let currentResource = new this._$resource('/api/get-current-data');
            this.requestInProgress = true;
            return currentResource.get()
                .$promise.then((data) => {
                    this.requestInProgress = false;
                    this.generateExpTime();
                    const dataToSave = data.toJSON();
                    if (_.isEmpty(dataToSave)) {
                        this.setDefaultParams();
                    } else {
                        if (_.isString(dataToSave.passedSteps)) {
                            dataToSave.passedSteps = [dataToSave.passedSteps,];
                        }
                        _.extend(this, dataToSave);
                    }
                }, () => {
                    this._$rootScope.$broadcast('showErrorDialog', {type: 'error'});
                    this.requestInProgress = false;
                });
        } else {
            return false;
        }
    }

    sendPingRequest() {
        let currentResource = new this._$resource('/api/continue-session');
        return currentResource.get().$promise
    }

    getOptions(key) {
        return this._options[key];
    }

    getHumanReadableName(key) {
        return this[key] ? this[key].name : '';
    }

    convertMetricToPSI(value) {
        return value / 25.4;
    }

    convertPSIToMetric(value) {
        return value * 25.4;
    }

    getWeightFactor() {
        return this.partWeightUnits === 'kg' ? 1000 : 2000;
    }

    calculateUtilizationInfo() {
        if (this.materialCost && this.utilization) {
            this.utilizationInfo = {
                priceUnit: this.priceUnit.value,
                utilization: parseFloat(this.utilization, 2).toFixed(0),
                costCoilSegment: this.coilSegmentWeight / this.getWeightFactor() * this.materialCost
            };
        }
    }

    getTotalRaw() {
        return this.partsNumber * this.coilSegmentWeight / this.getWeightFactor();
    }

    getTotalScrap() {
        return this.partsNumber * (this.coilSegmentWeight - this.partWeight) / this.getWeightFactor();
    }

    cleanUserDetails() {
        this.email = '';
        this.organization = '';
        this.name = '';
        this.company = '';
        this.phone = '';
        this.userLastName = '';
        this.phoneCode = '';
        this.addNumber = false;
    }
}

LoadedModel.$inject = ['$resource', '$state', '$rootScope', '$interval'];

let LoadedModelService = angular.module('app.common.services', [])
  .service('LoadedModel', LoadedModel)
  .name;


export default LoadedModelService



// WEBPACK FOOTER //
// ./client/app/common/services/loaded-model.js